(function () {
    "use strict";

    angular
        .module("common.services", [
            "ngResource",
            "ngAnimate",
            "angular-carousel",
        ]);

}());